"use strict";

import Vue from "vue";
import axios from "axios";

// Full config:  https://github.com/axios/axios#request-config
//axios.defaults.baseURL = "https://localhost:7016/api/";
axios.defaults.baseURL = "https://erp.matein3.com/api";
axios.defaults.headers = {
  "Content-Type": "application/json",
  Accept: "*/*",
};

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function (config) {
    config.headers = {
      Accept: "*/*",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    };
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    console.log(error.state);
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function (Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;
